import React from 'react'
import cx from "classnames";
import withStyles from 'isomorphic-style-loader/withStyles';
import Skeleton from '../../../Common/Skeleton/Skeleton';
import s from './OrderDetailsSkeleton.css'

function OrderDetailsSkeleton() {
    return (
        <div>
            <Skeleton className={s.orderDetailsSkeletonTitle} />
            <div className={s.orderDetailsSkeletonCardList}>
                {[1, 2].map((n) => {
                    return (
                        <div key={n}>
                            <Skeleton className={s.orderDetailsSkeletonCard} />
                        </div>
                    )
                })}
            </div>
            {[1, 2, 3].map((n) => {
                return (
                    <div className={cx(s[`orderDetailsSkeletonInfoItem${n}`])}>
                        <hr className={s.orderDetailsSkeletonDivider} />
                        <div key={n}>
                            <Skeleton className={s.orderDetailsSkeletonInfoTitle} />
                            <Skeleton className={s.orderDetailsSkeletonInfoDesc} />
                        </div>
                    </div>
                )
            })}
            <hr className={s.orderDetailsSkeletonDivider} />
            <div>
                <Skeleton className={s.orderDetailsSkeletonPhotoTitle} />
                <Skeleton className={s.orderDetailsSkeletonPhotoBox} />
            </div>
        </div>
    )
}

export default withStyles(s)(OrderDetailsSkeleton);
